import { useQuery } from "@tanstack/react-query";
import { fetchAllStates, fetchOneState } from "services/state";

export const useAllStates = (filters = {}) => {
  const query = useQuery({
    queryKey: ["all-states", filters],
    queryFn: () => fetchAllStates(filters),
    staleTime: 10 * 60 * 1000, // 10 minutes - states don't change often
  });
  return query;
};

export const useOneState = (id) => {
  const query = useQuery({
    queryKey: ["one-state", id],
    queryFn: () => {
      if (id) {
        return fetchOneState(id);
      }
    },
    enabled: !!id,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
  return query;
}; 